import moment from 'moment';
import React, { useState } from 'react';
import { View } from 'react-native';
import { Text } from 'react-native-elements';
import Colors from '../../../constants/Colorsv2';
import Styles from '../../../constants/Styles';
import { GroupMessageProps } from '../../../store/types/soc_svc';
import FormattedTextViewer from './FormattedTextViewer';
import MediaHolder from './MediaHolder';
import OrderHolder from './OrderHolder';
import URLPreviewCard from './URLPreviewCard';

type MessageCardProps = { navigation:any, groupMessage: GroupMessageProps, me_ind:boolean }
function MessageCard({ navigation, groupMessage, me_ind }: MessageCardProps ) {
    const [ message_width, setMessageWidth ] = useState(0)
    
    if(!groupMessage?.group_message_id){ return (<></>) }
    let media_size = 0
    if(groupMessage.message_images){ media_size += groupMessage.message_images.length }
    if(groupMessage.message_videos){ media_size += groupMessage.message_videos.length }
    const is_empty = !groupMessage.formatted_body?.blocks || groupMessage.formatted_body.blocks.length == 0 ? true : false
    if(me_ind){ 
        return (
            <View onLayout={(ev) => {
                const { width } = ev.nativeEvent.layout;
                setMessageWidth(width)
            }}>
                {groupMessage.formatted_body ?
                <View style={{ flexDirection:'row', alignItems:'flex-start', margin:5 }}>
                    <View style={{flex:2/8}} />
                    <View style={{flex:6/8, borderRadius:21, borderBottomRightRadius:0, backgroundColor:Colors.brand.midnight, padding:10, paddingLeft:16, paddingRight:16, marginBottom:4 }}>
                        {is_empty ?
                        <Text style={Styles.textStyles.whiteRegularLeft14}>{groupMessage.message}</Text>
                        :
                        <FormattedTextViewer post_id={groupMessage.group_message_id} formatted_body={groupMessage.formatted_body} view_type='message' text_fallback={groupMessage.message}/>
                        }
                    </View>
                </View>
                :<></>}
                <View nativeID='post-media'>
                    {media_size > 0 ?
                    <MediaHolder view_mode='view' width={message_width} images={groupMessage.message_images??[]} videos={groupMessage.message_videos??[]}/>
                    :<></>}
                    {groupMessage.message_orders && groupMessage.message_orders.length > 0 ?
                    <OrderHolder view_mode='view' width={message_width} order_ids={groupMessage.message_orders} />
                    :<></>}
                    {groupMessage.message_urls && groupMessage.message_urls.length > 0 ?
                    <URLPreviewCard view_mode='view' hide_image={media_size>0 || (groupMessage.message_orders && groupMessage.message_orders.length >0)?true:false} url_preview={groupMessage.url_metadata[0]} url={groupMessage.message_urls[0]} width={message_width}/>
                    :<></>}
                </View> 
                <Text style={Styles.textStyles.grey300RegularRight12}>Delivered - {moment(groupMessage.create_datetime).format('hh:mm')}</Text>
            </View>
            
        )
     }
    return (
        <View onLayout={(ev) => {
            const { width } = ev.nativeEvent.layout;
            setMessageWidth(width)
        }}>
            {groupMessage.formatted_body ? 
            <View style={{ flexDirection:'row', alignItems:'flex-start', margin:5 }}>
                <View style={{flex:6/8 }}>
                    <View style={{flex:1, borderRadius:21, borderBottomLeftRadius:0, backgroundColor:Colors.highlights.highlight200, padding:10, paddingLeft:16, paddingRight:16, marginBottom:4}}>
                        {is_empty ?
                        <Text style={Styles.textStyles.whiteRegularLeft14}>{groupMessage.message}</Text>
                        :
                        <FormattedTextViewer post_id={groupMessage.group_message_id} formatted_body={groupMessage.formatted_body} view_type='message' text_fallback={groupMessage.message}/>
                        }
                    </View>
                </View>
                <View style={{flex:2/8}} />
            </View>
            :<></>}
            <View nativeID='post-media'>
                {media_size > 0 ?
                    <MediaHolder view_mode='view' width={message_width} images={groupMessage.message_images??[]} videos={groupMessage.message_videos??[]}/>
                :<></>}
                {groupMessage.message_orders && groupMessage.message_orders.length > 0 ?
                <OrderHolder view_mode='view' width={message_width} order_ids={groupMessage.message_orders} />
                :<></>}
                {groupMessage.message_urls && groupMessage.message_urls.length > 0 ?
                <URLPreviewCard view_mode='view' hide_image={media_size>0 || (groupMessage.message_orders && groupMessage.message_orders.length >0)?true:false} url_preview={groupMessage.url_metadata[0]} url={groupMessage.message_urls[0]} width={message_width}/>
                :<></>}
            </View> 
            <Text style={Styles.textStyles.grey300RegularLeft12}>Delivered - {moment(groupMessage.create_datetime).format('hh:mm')}</Text>
        </View>
        
    )

}

export default MessageCard